exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-inDarkActive[data-v-1ce362de]:active{background-color:rgba(6,1,129,.3)!important}", ""]);

// exports
